<template>
  <div id="invite-create">
    <div class="page">
      <div
        class="card"
        :class="{ '-loading': loading }"
      >
        <div class="header">
          <div class="description">
            <h2 class="title">Enviar Convite</h2>
            <p class="subtitle">Nesta tela você pode cadastrar uma nova empresa e enviar o convite de acesso.</p>
          </div>
        </div>

        <div class="body">
          <div class="alert -danger mb-4" v-if="errors.cantCreate">
            <p class="title">Ocorreu um erro!</p>
            <p>Infelizmente não foi possível cadastrar esta empresa, por favor tente novamente.</p>
          </div>

          <form-invite
            submit-text="Cadastrar"
            v-model="form"
            :errors="errors.form"
            @submit="storeInvite"
          />
        </div>

        <loader v-if="loading"></loader>
      </div>
    </div>
  </div>

</template>

<script>
import FormInvite from '@/invite/components/FormInvite.vue';
import Loader from '@/support/components/Loader.vue';

export default {
  name: 'Create',

  data() {
    return {
      loading: false,
      form: {
        name: '',
        email: '',
        cnpj: '',
        organizationName: '',
      },
      errors: {
        cantCreate: false,
        form: {
          name: [],
          email: [],
          cnpj: [],
          organizationName: [],
        },
      },
    };
  },

  methods: {
    /**
     * Store the invite.
     *
     * @returns {Promise<void>}
     */
    async storeInvite() {
      try {
        this.resetErrors();
        this.loading = true;

        await this.$store.dispatch('invite/storeInvite', { form: this.form });
        await this.$router.push({ name: 'Invite-Index' });
      } catch (err) {
        const { data, status } = err.response || {};

        if (status === 422) {
          this.errors.form.name = data.errors.name || [];
          this.errors.form.email = data.errors.email || [];
          this.errors.form.cnpj = data.errors.cnpj || [];
          this.errors.form.organizationName = data.errors.organizationName || [];
          return;
        }

        this.errors.cantCreate = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset errors.
     */
    resetErrors() {
      this.errors.cantCreate = false;
      this.errors.form.name = [];
      this.errors.form.email = [];
      this.errors.form.cnpj = [];
      this.errors.form.organizationName = [];
    },
  },


  components: {
    FormInvite,
    Loader,
  },
};
</script>
